import { Type } from "@sinclair/typebox";
import { TypeBoxToType } from "@whatslly/types/TypeBoxToType";
import { ApiErrorResponse } from "@whatslly/types/ApiErrorResponse";
import { OrgConfigs } from "../OrgConfigs";

export const PlatformType = Type.Union([Type.Literal("slack"), Type.Literal("discord"), Type.Literal("tuvisTeamsApp")]);
export type PlatformType = TypeBoxToType<typeof PlatformType>;
export const PLATFORM_TYPES = {
  SLACK: "slack",
  DISCORD: "discord",
  TUVIS_TEAMS_APP: "tuvisTeamsApp",
} as const;
export const platformTypeOptions: {
  label: string;
  value: PlatformType;
  orgConfigKey: keyof Pick<OrgConfigs, "allow_slack_platform">;
}[] = [
  {
    label: "Slack",
    value: PLATFORM_TYPES.SLACK,
    orgConfigKey: "allow_slack_platform",
  },
];
export const ImPlatform = Type.Object({
  _id: Type.String(),
  orgId: Type.String(),
  platformType: PlatformType,
  platformWorkspaceId: Type.String(),
  platformWorkspaceName: Type.String(),
  scope: Type.String(),
  metadata: Type.Record(Type.String(), Type.Any()),
  apiKey: Type.String(),
  active: Type.Boolean(),
  createdAt: Type.String(),
  updatedAt: Type.String(),
});
export type ImPlatform = TypeBoxToType<typeof ImPlatform>;

export const GetPlatformsQuery = Type.Object({
  orgId: Type.String(),
});
export type GetPlatformsQuery = TypeBoxToType<typeof GetPlatformsQuery>;

export const GetPlatformsResponseSuccess = Type.Object({
  success: Type.Literal(true),
  platforms: Type.Array(ImPlatform),
});
export const GetPlatformsResponse = Type.Union([GetPlatformsResponseSuccess, ApiErrorResponse]);
export type GetPlatformsResponse = TypeBoxToType<typeof GetPlatformsResponse>;

export const InstallPlatformQuery = Type.Object({
  orgId: Type.String(),
});
export type InstallPlatformQuery = TypeBoxToType<typeof InstallPlatformQuery>;

export const InstallPlatformBody = Type.Object({
  platformType: PlatformType,
  tokens: Type.String(),
  integrationData: Type.Object({
    teamId: Type.Optional(Type.String()),
    teamName: Type.Optional(Type.String()),
    tenantId: Type.Optional(Type.String()),
    tenantName: Type.Optional(Type.String()),
    botUserId: Type.Optional(Type.String()),
    appId: Type.Optional(Type.String()),
    scope: Type.Optional(Type.String()),
    dummyUserId: Type.Optional(Type.String()),
  }),
});
export type InstallPlatformBody = TypeBoxToType<typeof InstallPlatformBody>;

export const InstallPlatformResponseSuccess = Type.Object({
  success: Type.Literal(true),
});
export const InstallPlatformResponse = Type.Union([InstallPlatformResponseSuccess, ApiErrorResponse]);
export type InstallPlatformResponse = TypeBoxToType<typeof InstallPlatformResponse>;

export const UpdatePlatformMetadataParams = Type.Object({
  platformId: Type.String(),
});
export type UpdatePlatformMetadataParams = TypeBoxToType<typeof UpdatePlatformMetadataParams>;

export const UpdatePlatformMetadataBody = Type.Object({
  whatsappTemplateShortcutTrigger: Type.String(),
});
export type UpdatePlatformMetadataBody = TypeBoxToType<typeof UpdatePlatformMetadataBody>;

export const UpdatePlatformMetadataResponseSuccess = Type.Object({
  success: Type.Literal(true),
});
export const UpdatePlatformMetadataResponse = Type.Union([UpdatePlatformMetadataResponseSuccess, ApiErrorResponse]);
export type UpdatePlatformMetadataResponse = TypeBoxToType<typeof UpdatePlatformMetadataResponse>;

export const UninstallPlatformParams = Type.Object({
  platformId: Type.String(),
});
export type UninstallPlatformParams = TypeBoxToType<typeof UninstallPlatformParams>;

export const UninstallPlatformResponseSuccess = Type.Object({
  success: Type.Literal(true),
});
export const UninstallPlatformResponse = Type.Union([UninstallPlatformResponseSuccess, ApiErrorResponse]);
export type UninstallPlatformResponse = TypeBoxToType<typeof UninstallPlatformResponse>;

export const PlatformAuthExchangeBody = Type.Object({
  platformType: PlatformType,
  workspaceId: Type.String(),
  apiKey: Type.String(),
});
export type PlatformAuthExchangeBody = TypeBoxToType<typeof PlatformAuthExchangeBody>;

export const PlatformAuthExchangeResponseSuccess = Type.Object({
  success: Type.Literal(true),
  etoken: Type.String(),
  orgId: Type.String(),
  expiresIn: Type.Number(),
});
export const PlatformAuthExchangeResponse = Type.Union([PlatformAuthExchangeResponseSuccess, ApiErrorResponse]);
export type PlatformAuthExchangeResponse = TypeBoxToType<typeof PlatformAuthExchangeResponse>;
